import { lazy, Suspense, useState } from 'react';
import { Button } from '@/components/ui/button.tsx';
import { useLoggedInAccounts } from '@/hooks/useLoggedInAccounts';
import { AccountSwitcher } from './AccountSwitcher';
import { cn } from '@/lib/utils';

// Lazy: the auth dialog carries QR generation, bunker connect, and the whole
// signup flow — none of it needed until the user actually opens it.
const AuthDialog = lazy(() => import('./AuthDialog'));

export interface LoginAreaProps {
  className?: string;
}

export function LoginArea({ className }: LoginAreaProps) {
  const { currentUser } = useLoggedInAccounts();
  const [authDialogOpen, setAuthDialogOpen] = useState(false);

  return (
    <div className={cn('inline-flex items-center justify-center', className)}>
      {currentUser ? (
        <AccountSwitcher onAddAccountClick={() => setAuthDialogOpen(true)} />
      ) : (
        <Button
          onClick={() => setAuthDialogOpen(true)}
          className="flex items-center gap-2 px-5 py-2 rounded-full bg-primary text-primary-foreground font-medium transition-all hover:bg-primary/90 animate-scale-in"
        >
          <span className="truncate">Join</span>
        </Button>
      )}

      {authDialogOpen && (
        <Suspense fallback={null}>
          <AuthDialog
            isOpen={authDialogOpen}
            onClose={() => setAuthDialogOpen(false)}
          />
        </Suspense>
      )}
    </div>
  );
}
